import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import ListDashboard from '@/components/ListDashboard'
import Settings from '@/components/Settings'
import PostPage from '@/components/PostPage'
import UserProfile from '@/components/UserProfile'
import PostsMap from '@/components/PostsMap'
import Visualization from '@/components/Visualization'


Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/dashboard'
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
    {
			path: '/dashboard',
			name: 'Dashboard',
			component: Dashboard,
	      meta: {
	          requiresAuth: true
	      }
		},
		{
			path: '/dashboard/:mode/',
			name: 'DashboardMode',
			component: Dashboard,
				meta: {
						requiresAuth: true
				}
		},
		{
			path: '/post/:id',
			name: 'Post',
			component: PostPage
	 	},
		{
			path: '/list/:id',
			name: 'List',
			component: ListDashboard
		},
		{
			path: '/user/:id',
			name: 'UserProfile',
			component: UserProfile
		},
		{
			path: '/viz/:style/:mode/:id',
			name: 'Visualization',
			component: Visualization
		}
	]
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser

    if (requiresAuth && !currentUser) {
        next('/login')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js